import { Popup } from 'components/Popup'
import { Button, BUTTON_TYPES } from 'components/Button'
import { BTN_TXT } from 'constants/txt'
import { Typography } from 'components/Typography'
import { useMemo } from 'react'
import { HOSPITAL_STATUS_TO_STATUS } from 'components/Status'
import { setLoading } from 'redux/store/common/slice'
import {
  activateHospitals,
  archiveHospitals
} from '../../../../../../HealthSystemDetails/HospitalsTable/api'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getUser } from 'redux/store/user/getters'

export const ActionModal = ({
  details,
  setOpenModal,
  openModal,
  handleHospitalForEdit
}) => {
  const dispatch = useDispatch()
  const { id } = useParams()
  const user = useSelector(getUser)
  const isArchiveStatus = useMemo(() => {
    return details.status === HOSPITAL_STATUS_TO_STATUS.archived
  }, [details.status])

  const handleSubmit = async () => {
    if (!user.community || !id) return
    dispatch(setLoading(true))
    try {
      if (isArchiveStatus) {
        await activateHospitals(user.community, id, {
          hospital: details.uuid
        })
      } else {
        await archiveHospitals(user.community, id, {
          hospitals: [details.uuid]
        })
      }
      handleHospitalForEdit()
      setOpenModal(false)
    } catch (e) {
      console.error(e)
    } finally {
      dispatch(setLoading(false))
    }
  }

  return (
    <>
      <Popup
        visible={openModal}
        onCancel={() => setOpenModal(false)}
        title={`${isArchiveStatus ? 'Re-activate' : 'Archive'} hospital?`}
        wrapClassName="popup-over"
        width={442}
        footer={
          <>
            <Button
              onClick={() => setOpenModal(false)}
              type={BUTTON_TYPES.DEFAULT}
              upperCase
            >
              {BTN_TXT.CANCEL}
            </Button>
            <Button
              type={BUTTON_TYPES.PRIMARY}
              onClick={handleSubmit}
              upperCase
              danger={!isArchiveStatus}
            >
              {isArchiveStatus ? BTN_TXT.RE_ACTIVATE : BTN_TXT.ARCHIVE}
            </Button>
          </>
        }
      >
        {isArchiveStatus ? (
          <Typography.Body1>
            You are about to re-activate {details.name}.
          </Typography.Body1>
        ) : (
          <Typography.Body1>
            Users might have contracts.
            <br />
            Do you really want to archive Hospital?
          </Typography.Body1>
        )}
      </Popup>
    </>
  )
}
